export const auPostalCodeValidation = '^\\d{4}$';
